<template>
  <DialogDef2 label="資訊移動確認" :show="item" @close="$emit('close')" :haadBg="'#7FA7DA'" :width="'720'" :style="{right: '480px'}">
    <div class="fields">
      <div class="field">
        <div>預約日期:</div>
        <div>{{toDate(item.visitDate)}}</div>
      </div>
      <div class="field">
        <div>預約時段:</div>
        <div>{{item.visitTime}}</div>
      </div>
      <div class="field">
        <div>預約人:</div>
        <div>{{item.orderer}}</div>
      </div>
      <div class="field">
        <div>聯絡電話:</div>
        <div>{{item.ordererTel}}</div>
      </div>
      <div class="field">
        <div>旅行社:</div>
        <div>{{item.agency?.name}}</div>
      </div>
      <div class="field">
        <div>統一編號:</div>
        <div>{{item.agencyID}}</div>
      </div>
    </div>
    <hr>
    <div id="storeSelect">{{item.store}} → <Select1 :width="'393px'" :height="'55px'" align="center" :color="'#7FA7DA'" :borderColor="'#8C8C8C'"
    :defaultValue="store" @input="store=$event"><option v-for="(opt, o) in storeOptions" :key="`opt-${o}`" :value="opt">{{opt}}</option></Select1></div>
    <div id="warningLine">確定要移動預約資訊嗎?</div>
    <div id="psline">※移動資訊包含，預約日期/預約人/預約電話等基本資訊※<br>※訂金資訊與備註資訊※</div>
    <div class="btns">
      <button :style="{backgroundColor: '#C4C4C4'}" @click="$emit('close')">取消</button>
      <button :style="{backgroundColor: '#7FA7DA'}" @click="move" :disabled="!store">確認移動</button>
    </div>
  </DialogDef2>
</template>

<script>
import { mapState } from 'vuex'
import { postapi } from '../../store/fetch.js'
export default {
  props: ['item'],
  data () {
    return {
      store: null
    }
  },
  computed: {
    storeOptions () {
      const orgStoreType = this.$store.getters.getStoreType(this.item.store)
      const rs = (this.restaurants || []).map(e => { return { name: e.name, type: e.storeType } })
      const rs_same = rs.filter(e => e.type === orgStoreType)
      const rs_diff = rs.filter(e => e.type !== orgStoreType)
      return [...rs_same, ...rs_diff].map(e => e.name).filter(e => e !== this.item.store)
    },
    ...mapState({
      restaurants: 'restaurantsInfos'
    })
  },
  created () {
    if (!this.store) {
      this.store = this.storeOptions[0] || null
    }
  },
  watch: {
    storeOptions: {
      immediate: true,
      handler () {
      }
    }
  },
  methods: {
    async move () {
      const r = await postapi(`restaurant/movesheet/${this.item._id}`, { store: this.store })
      if (r) {
        this.$emit('moved', r)
      }
    }
  }
}
</script>

<style lang="scss">
#storeSelect {
  label::before {
    background-color: #7FA7DA;
  }
  select {
    font-weight: 700!important;
    font-size: 30px;
    letter-spacing: .1em;
  }
}
</style>
<style lang="scss" scoped>
#warningLine {
  color: var(--highlight);
  font-size: 28px;
  font-weight: 700;
  letter-spacing: .1em;
  margin-top: 12px;
}
#psline {
  font-size: 20px;
  font-weight: 500;
  letter-spacing: .1em;
  color: #8C8C8C;
}
#storeSelect {
  display: flex;
  align-items: center;
  font-size: 36px;
  font-weight: 700;
  letter-spacing: .1em;
  justify-content: center;
  color: var(--color-pri);
  margin-top: 20px;
  gap: .5em;
}
.btns {
  display: grid;
  grid-template-columns: 1fr 2fr;
  padding: 29px 36px;
  gap: 22px;
  button {
    height: 55px;
    width: 100%;
    color: #FFFFFF;
    letter-spacing: .05em;
    font-size: 20px;
    line-height: 30px;
    font-weight: 500;
    border-radius: 3px;
  }
}
.fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 20px 49px;
}
hr {
  margin-inline: 27px;
  background-color: #C4C4C4;
  width: calc(100% - 54px);
  height: 1px;
  border: none;
}
.field {
  width: 100%;
  min-height: 40px;
  height: fit-content;
  display: grid;
  grid-template-columns: 100px 1fr;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: .1em;
  line-height: 30px;
  text-align: start;
  color: #8C8C8C;
}
</style>
